import { Icon } from '@telus-uds/components-web'
import { SparkleFilled } from '@telus-uds/palette-allium/build/web/icons'
import { MessageTagWrapper, MessageTagIconWrapper, MessageBubble } from './Styles'
import { WelcomeMessage } from './types'

export interface WelcomeMessageItemProps {
  message: WelcomeMessage
  welcomeTagLabel?: string
}

const WelcomeMessageItem = ({ message, welcomeTagLabel }: WelcomeMessageItemProps) => (
  <div data-message-id={message.id}>
    {welcomeTagLabel && (
      <MessageTagWrapper messageType="Assistant">
        <MessageTagIconWrapper>
          {/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment */}
          <Icon icon={SparkleFilled} variant={{ size: 'large', rank: 'primary' }} />
        </MessageTagIconWrapper>
        {welcomeTagLabel}
      </MessageTagWrapper>
    )}
    <MessageBubble messageType="Assistant">{message.content}</MessageBubble>
  </div>
)

export default WelcomeMessageItem
